export default __webpack_public_path__ + "media/images/20-cdfb2cc32aca64898650b775065bbaf6.jpg";